import React from 'react';
import AccordionSummary, { type AccordionSummaryProps } from '@mui/material/AccordionSummary';
import ExpandMoreIcon from '@mui/icons-material/ExpandMoreRounded';
import ExpandLessIcon from '@mui/icons-material/ExpandLessRounded';
import Typography from '@mui/material/Typography';
import clsx from 'clsx';

import { Flex } from 'src/components/flex';

import styles from 'src/components/accordion-section/AccordionSectionHeader.module.css';

type Props = AccordionSummaryProps & {
    title?: React.ReactNode;
    meta?: React.ReactNode;
    leading?: React.ReactNode;
    trailing?: React.ReactNode;
    expanded?: boolean;
};

export default function AccordionSectionHeader({
    children,
    title,
    meta,
    leading,
    trailing,
    expanded,
    ...props
}: Props) {
    const icon = expanded ? <ExpandLessIcon color="action" /> : <ExpandMoreIcon color="action" />;

    return (
        <AccordionSummary
            component="div"
            classes={{
                root: styles.root,
                content: styles.content,
            }}
            {...props}
        >
            {children ?? (
                <div className={styles.row}>
                    <div className={styles.left}>
                        {leading}
                        <div className={styles.label}>
                            {icon}
                            <Typography className={clsx(styles.title, 'ellipsisText')}>{title}</Typography>
                            {meta != null && (
                                <Typography className={styles.meta}>
                                    {meta}
                                </Typography>
                            )}
                        </div>
                    </div>

                    {trailing && (
                        <Flex alignItems="center">
                            {trailing}
                        </Flex>
                    )}
                </div>
            )}
        </AccordionSummary>
    );
}
